import { useEffect } from 'react';

interface ShortcutHandlers {
  onQuickSwitcher?: () => void;
  onFocusComposer?: () => void;
  onReplyLast?: () => void;
  onEditLast?: () => void;
  onJumpUp?: () => void;
  onEscape?: () => void;
}

// Task #1660 — shortcuts globali Messenger v2.
//   ⌘K / Ctrl+K → QuickSwitcher
//   e           → focus composer (quando NON sei in input)
//   r           → reply ultimo messaggio
//   ↑ (composer vuoto) → edit ultimo messaggio mio
//   Esc         → chiudi modali/picker
//
// Gli handler con context (focus su input/textarea) bypassano l'evento
// per non interferire con il typing.

function isTypingTarget(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable;
}

export function useMessengerShortcuts(h: ShortcutHandlers) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      // ⌘K / Ctrl+K → quick switcher (sempre, anche da input)
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        if (h.onQuickSwitcher) { e.preventDefault(); h.onQuickSwitcher(); }
        return;
      }
      if (e.key === 'Escape') {
        h.onEscape?.();
        return;
      }
      // Le scorciatoie single-letter scattano solo fuori da input/textarea
      if (isTypingTarget(e.target)) return;
      if (e.key === 'e' && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); h.onFocusComposer?.(); }
      else if (e.key === 'r' && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); h.onReplyLast?.(); }
      else if (e.key === 'ArrowUp' && !e.metaKey && !e.ctrlKey && !e.altKey) { h.onJumpUp?.(); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [h]);
}
